import { IDrugTestingLabTest, IFacilityAddress, ThirdPartyDrugTestResultStatus } from 'models/drugTesting';

export enum TabIndex {
  APPOINTMENTS = 0,
  THIRD_PARTY_RESULTS = 1,
}

// Reason text is clamped to 2 lines; only offer "View More" when it's long
// enough to actually be truncated.
export const REASON_VIEW_MORE_CHAR_LIMIT = 80;

export interface IDrugTestAppointment {
  id: string;
  facilityName: string;
  appointmentDate: string;
  companyName: string;
  projectName: string;
  typeName: string;
  panelName: string;
  reason: string;
  // Raw API fields preserved for downstream actions (edit, view more, etc.)
  workerId?: string;
  projectId?: string;
  testScheduledForDate?: string;
  facilityId?: string;
  drugTestingTypeId?: string;
  panelId?: string;
  panelTests?: string[];
  status?: number;
  actionStatus?: number;
  drugTestingScheduleResult?: number;
  // Raw fields backing the extended Worker-App-parity view (Address, Substance,
  // Test Result, BAT Result, Details). Kept raw so the card derives display values.
  facilityAddress?: IFacilityAddress | null;
  resultSentToLabTestSubstances?: IDrugTestingLabTest[];
  batTestResult?: string | null;
  batConfirmationTestResult?: string | null;
  drugTestingScheduleInvalidResultType?: number;
  invalidResultTypeFreeText?: string | null;
  resultTypeFreeText?: string | null;
}

export interface ITestResultAttachment {
  id: string;
  fileName: string;
  url?: string;
}

export interface IThirdPartyTestResult {
  id: string;
  facilityName: string;
  appointmentDate: string;
  companyName: string;
  projectName: string;
  typeName: string;
  panelName: string;
  reason: string;
  testResult: string;
  // Raw numeric status from the API: 0 = Pending, 1 = Approved, 2 = Denied.
  resultStatus: ThirdPartyDrugTestResultStatus;
  substance: string;
  attachments: ITestResultAttachment[];
  // Raw API fields preserved for edit prefill.
  projectId?: string;
  panelId?: string;
  drugTestingTypeId?: string;
  resultValue?: number;
  testedAt?: string;
}

export interface IAppointmentCounts {
  appointments: number;
  thirdPartyResults: number;
}
